import { evaluateStraplineConditions, filterOutContentByUrl } from '@/shared/utils';
import { StrapLineConfig, StraplineContent } from '../../../../../common/src';

const PRIMARY_BACKGROUND_COLOR = 'var(--color-primary-500)';

export type VisibleStraplines = Record<string, { backgroundColor: string; straplineContent: StraplineContent }>;

/** Single source of truth for which straplines TheStrapLine renders on a route. */
export function filterVisibleStraplines(
  items: Record<string, StrapLineConfig>,
  currentRoute: string,
  selectedLanguage: string | undefined
): VisibleStraplines {
  const visibleItems: VisibleStraplines = {};

  for (const [url, item] of Object.entries(items)) {
    if (!filterOutContentByUrl(url, currentRoute) || !evaluateStraplineConditions(item.conditions)) {
      continue;
    }

    const straplineContent = item.straplineContent.find(content => content.language === selectedLanguage);
    if (!straplineContent?.value) {
      continue;
    }

    visibleItems[url] = { backgroundColor: item.backgroundColor, straplineContent };
  }

  return visibleItems;
}

/** Background color of the first strapline TheStrapLine will render, so wrapper and content agree. */
export function getStraplineBackgroundColor(
  items: Record<string, StrapLineConfig>,
  currentRoute: string,
  selectedLanguage: string | undefined
): string {
  const [first] = Object.values(filterVisibleStraplines(items, currentRoute, selectedLanguage));
  return first?.backgroundColor || PRIMARY_BACKGROUND_COLOR;
}
